export const LOG_IN = 'user/LOG_IN';
export const LOG_OUT = 'user/LOG_OUT';
export const REFRESH_ACCESS_TOKEN = 'user/REFRESH_ACCESS_TOKEN';



// WEBPACK FOOTER //
// ./src/store/modules/user/mutation-types.js